module.exports = __webpack_public_path__ + "static/media/PM74.a56fcabe.png";